//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import value from './value';
export default {
  data: function data() {
    return {
      value: value
    };
  },
  methods: {
    handleAddRow: function handleAddRow() {
      this.value += '<p style="color: #409EFF;">我是新增的行</p>';
    },
    textChangeHandler: function textChangeHandler(delta, oldDelta, source) {// console.group('QuillEditor textChangeHandler')
      // console.log(delta, oldDelta, source)
      // console.groupEnd()
    },
    selectionChangeHandler: function selectionChangeHandler(range, oldRange, source) {// console.group('QuillEditor selectionChangeHandler')
      // console.log(range, oldRange, source)
      // console.groupEnd()
    },
    editorChangeHandler: function editorChangeHandler(eventName) {// console.group('QuillEditor editorChangeHandler')
      // console.log(eventName, args)
      // console.groupEnd()
    }
  }
};